import { EmployerSignupStatus } from '@zorro/clients';
import { APP_ROUTES } from '@zorro/common-utils';
import { $enum } from 'ts-enum-util';

export const getFormStatusesConfig = (
  signupStatus?: EmployerSignupStatus
):
  | {
      submitLabel: string;
      successMessage?: string;
      nextSignupStatus?: EmployerSignupStatus;
      navigateTo?: keyof typeof APP_ROUTES;
      shouldActivateEmployerAdmin?: boolean;
      shouldShowSkipInvitation?: boolean;
      isZorroOnly?: boolean;
    }
  | undefined => {
  return $enum.mapValue(signupStatus).with({
    [EmployerSignupStatus.DRAFT]: {
      submitLabel: 'Invite employer to complete',
      shouldShowSkipInvitation: true,
    },
    [EmployerSignupStatus.NEEDS_REVIEW]: {
      nextSignupStatus: EmployerSignupStatus.IN_ZORRO_SETUP,
      successMessage: 'Employer successfully finalized',
      submitLabel: 'Finalize',
    },
    [EmployerSignupStatus.IN_ZORRO_SETUP]: {
      nextSignupStatus: EmployerSignupStatus.ACTIVE,
      successMessage: 'Employer activated successfully',
      shouldActivateEmployerAdmin: true,
      submitLabel: 'Activate account',
      navigateTo: 'OPS_EMPLOYERS_OVERVIEW',
      isZorroOnly: true,
    },
    [EmployerSignupStatus.WAITING_FOR_EMPLOYER]: undefined,
    [EmployerSignupStatus.PROSPECT]: undefined,
    [EmployerSignupStatus.ACTIVE]: undefined,
    [$enum.handleUnexpected]: undefined,
    [$enum.handleUndefined]: undefined,
  });
};
